export const SEGMENTS = {
  PROFILE: "profile",
  PROJECT: "project",
  TEAM: "team",
  WHATSAPP: "whatsapp",
  ANALYTICS: "analytics",
  PRACTITIONERS: "practitioners",
  MY_SCHEDULE: "my-schedule",
  INTEGRATIONS: "integrations",
  AGENT_CONFIGURATION: "agent-configuration",
  AGENT_KORA: "kora",
  AGENT_FOLLOW_UPS: "follow-ups",
  AGENT_ESCALATION_CONFIGURATION: "escalation-configuration",
  CLINIC_CONFIGURATION: "clinic-configuration",
  CLINIC_DETAILS: "details",
  CLINIC_PRACTITIONERS: "doctors",
  CLINIC_LOCATIONS: "locations",
  CLINIC_SERVICES: "services",
  /**
   * The child route of a resource page that creates a record.
   */
  CREATE_RESOURCE: "new",
};

export const ROUTES = {
  HOME: "/",

  /**
   * Auth routes
   */
  LOGIN: "/login",
  SIGNUP: "/signup",
  RESET_PASSWORD: "/reset-password",
  SET_PASSWORD: "/set-password",

  PROFILE: `/${SEGMENTS.PROFILE}`,
  PROJECT: `/${SEGMENTS.PROJECT}`,
  TEAM: `/${SEGMENTS.TEAM}`,
  WHATSAPP: `/${SEGMENTS.WHATSAPP}`,
  ANALYTICS: `/${SEGMENTS.ANALYTICS}`,
  PRACTITIONERS: `/${SEGMENTS.PRACTITIONERS}`,
  MY_SCHEDULE: `/${SEGMENTS.MY_SCHEDULE}`,
  GOOGLE_CALENDAR_CALLBACK: `/${SEGMENTS.INTEGRATIONS}/google/calendar`,
  AGENT_CONFIGURATION: `/${SEGMENTS.AGENT_CONFIGURATION}`,
  AGENT_KORA: `/${SEGMENTS.AGENT_CONFIGURATION}/${SEGMENTS.AGENT_KORA}`,
  AGENT_FOLLOW_UPS: `/${SEGMENTS.AGENT_CONFIGURATION}/${SEGMENTS.AGENT_FOLLOW_UPS}`,
  AGENT_ESCALATION_CONFIGURATION: `/${SEGMENTS.AGENT_CONFIGURATION}/${SEGMENTS.AGENT_ESCALATION_CONFIGURATION}`,
  CLINIC_CONFIGURATION: `/${SEGMENTS.CLINIC_CONFIGURATION}`,
  CLINIC_DETAILS: `/${SEGMENTS.CLINIC_CONFIGURATION}/${SEGMENTS.CLINIC_DETAILS}`,
  CLINIC_PRACTITIONERS: `/${SEGMENTS.CLINIC_CONFIGURATION}/${SEGMENTS.CLINIC_PRACTITIONERS}`,
  CREATE_CLINIC_PRACTITIONER: `/${SEGMENTS.CLINIC_CONFIGURATION}/${SEGMENTS.CLINIC_PRACTITIONERS}/${SEGMENTS.CREATE_RESOURCE}`,
  CLINIC_LOCATIONS: `/${SEGMENTS.CLINIC_CONFIGURATION}/${SEGMENTS.CLINIC_LOCATIONS}`,
  CREATE_CLINIC_LOCATION: `/${SEGMENTS.CLINIC_CONFIGURATION}/${SEGMENTS.CLINIC_LOCATIONS}/${SEGMENTS.CREATE_RESOURCE}`,
  CLINIC_SERVICES: `/${SEGMENTS.CLINIC_CONFIGURATION}/${SEGMENTS.CLINIC_SERVICES}`,
  CREATE_CLINIC_SERVICE: `/${SEGMENTS.CLINIC_CONFIGURATION}/${SEGMENTS.CLINIC_SERVICES}/${SEGMENTS.CREATE_RESOURCE}`,
};
